



















import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { FilterComponentMixin } from '@/mixins/filter-component.mixin'
import { CommonMixin } from '@/mixins/common.mixin'
import _ from 'lodash'
import { Ajax, queryParams, SelectOptions } from '@/interfaces/filter'

@Component
export default class SelectFilter extends mixins(FilterComponentMixin, CommonMixin) {
  items = _.get(this.filter, 'select.items', [])

  get select(): SelectOptions {
    return _.get(this.filter, 'select', {})
  }

  get ajax(): Ajax | undefined {
    return this.select.ajax
  }

  get idField(): string {
    return _.get(this.ajax, 'idField', 'id')
  }

  get textField(): string {
    return _.get(this.ajax, 'textField', 'name')
  }

  get multiple(): boolean {
    return this.select.multiple || false
  }

  get queryHandler(): Function {
    return this.ajax!.queryHandler || this.defaultQueryHandler
  }

  get resultHandler(): Function {
    return this.ajax!.resultHandler || this.defaultResultHandler
  }

  get itemIds(): Number[] {
    let ids = this.filter.value
    return ids && this.multiple && !Array.isArray(ids) ? [ids] : ids
  }

  get queryParams(): queryParams | null {
    let ids = this.itemIds
    return ids && ids.length ? { filter: { id: { $in: ids } } } : null
  }

  async handleSearch(value): Promise<void> {
    if (!this.ajax || !value || this.ajax.preload) return

    this.items = []

    if (value.length < 3) return

    let result = await this.$api.get(this.ajax.url, {
      params: this.queryHandler(value)
    })

    this.items = this.resultHandler(result)
  }

  handleChange(value): void {
    if (Array.isArray(value) && !value.length && !this.ajax!.preload) this.items = []
  }

  defaultResultHandler(result): any[] {
    return _.get(result, 'data.items', [])
  }

  defaultQueryHandler(value): queryParams {
    let { queryName } = this.ajax!
    if (!queryName) return {}

    return {
      filter: {
        [queryName]: {
          $iLike: value
        }
      }
    }
  }

  async created(): Promise<void> {
    let { queryParams, ajax: { preload = null } = {} } = this

    if (preload || queryParams) {
      let result = await this.$api.get(this.ajax!.url, {
        params: preload ? undefined : queryParams
      })
      this.items = this.resultHandler(result)
    }
  }
}
